import React from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { FormattedMessage } from "react-intl";

class CheckboxGroup extends React.Component {
  static propTypes = {
    required: PropTypes.bool,
    options: PropTypes.array,
    input: PropTypes.object,
    meta: PropTypes.object
  };

  checkboxGroup() {
    const {
      options,
      input,
      meta: { touched, error, warning }
    } = this.props;
    return options.map((option, index) => {
      return (
        <li className="checkbox" key={index}>
          <input
            id={`answer-${option.value}`}
            type="checkbox"
            name={`${input.name}[${index}]`}
            value={option.value}
            checked={input.value.indexOf(option.value) !== -1}
            onChange={event => {
              const newValue = [...input.value];
              if (event.target.checked) {
                newValue.push(option.value);
              } else {
                newValue.splice(newValue.indexOf(option.value), 1);
              }
              return input.onChange(newValue);
            }}
          />
          <label htmlFor={`answer-${option.value}`}>
            <span>{option.label}</span>
          </label>
          {touched &&
            ((error && <span><FormattedMessage id={error} /></span>) ||
              (warning && <span><FormattedMessage id={warning} /></span>))
          }
        </li>
      );
    });
  }

  render() {
    return <div>{this.checkboxGroup()}</div>;
  }
}
const CheckboxGroupField = props => (
  <Field component={CheckboxGroup} {...props} />
);

export default CheckboxGroupField;



// WEBPACK FOOTER //
// ./src/modules/forms/fields/checkbox-group-field.js